<template>
    <div >
      <b-row>
          <b-col md="12">
            <MdTitle v-bind:Text="$t('ControlledDrugsRegisterRep.ReportTitle')" />
          </b-col>
      </b-row>
      <b-row>
          <div class="col-sm-12 col-md-12 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                  <div class="input-group"  dir="ltr">
                      <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                          @keyup.enter="LoadControlledDrugs" />

                      <div class="input-group-append">
                          <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'" v-on:click="LoadControlledDrugs">
                          </MdButton>
                      </div>
                  </div>
              </div>
          </div>
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'ControllerDrugsRegisterReportDateFrom'"
              :Type="'date'"  
              :OnPressEnter="LoadControlledDrugs"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'ControllerDrugsRegisterReportDateTo'"
              :OnPressEnter="LoadControlledDrugs"    
              :Type="'date'"             
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateToValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <!-- <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>  -->
            <MdLookupMultiSelect
                v-bind:Label="$tc('Shared.Patient',2)"
                v-bind:ModelCode="PatientCodeModel"
                v-bind:RefCode="'patientcode'"
                v-bind:Api="'Patients'"
                v-bind:FieldCode="'patientcode'"
                v-bind:FieldDescription="'firstname'"
                :SearchTitle="$tc('Shared.Patient',2)"
                :GetValues="getValues"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'PatientCode'"
                :AuxFields="AuxFields"
                :Placeholder="$t('schedule_sample.sPatient')"
                :FieldsDate="fieldsDate"
                v-bind:Fields="BaseFields"
            />
          </b-col>
            
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('Medication.Drugs')"
              v-bind:Options="DrugList"
              v-bind:Model="DrugsCodeModel"
              v-bind:FieldDescription="'drugname'"
              v-bind:FieldCode="'drugCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('DrugsMovementRep.Trans')"
              v-bind:Options="TranOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="true"
              v-bind:Model="TranModel"  
              :Input="ChangeTran"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="false"                      
                :Input="ChangeDropDownLoc"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              v-bind:Label="$t('Shared.Show')"
              v-model="show"
              v-bind:Options="showOptions"
              v-bind:Name="'show'"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadControlledDrugs"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>
      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('ControlledDrugsRegisterRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportControlledDrugsFilters"
          :ReportName="'DrugControllerRegister'"
          :ReportTitle="$t('ControlledDrugsRegisterRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('ControlledDrugsRegisterRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/ControlledDrugsRegister/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PatientService from '@/services/patient.service'
  import UtilsService from '@/services/utils.service'
  import StorageService from '@/services/storage.service'
  import Utils from '@/common/utils'
  import { EventBus } from '@/event-bus.js';
  
  export default Vue.extend({
      name: "ControlledDrugsRegisterRep",
      mixins: [ ShowMessage, PharmacyRepFunctions, DBFunctions],
      components: { DxPopup },
      data() {
          return {
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              DrugList:[],
              PatientsList: [],
              PatientCodeModel: [],
              DrugsCodeModel:'',
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                PatientCode: '',
                LocList:'',
                Tran: ''
              },
              TranModel: '',
              TranOptions: [
                {"value":"ADMINISTER","name":this.$t('Shared.Administer')},
                {"value":"DISPENSING","name":this.$t('Shared.Dispensing')},
                {"value":"RECEIVED","name":this.$t('Shared.Received')},
                {"value":"RECEIVED_RELOCATION","name":this.$t('Shared.ReceivedRelocation')},
                {"value":"RELOCATION","name":this.$t('Shared.Relocation')},
                {"value":"RETURNED","name":this.$t('Shared.Returned')},
                {"value":"REMOVED","name":this.$t('Shared.Removed')}
              ],
              showOptions: [
                { value: 0, text: this.$t('ControlledDrugsRegisterRep.PharmacyBook') },
                { value: 1, text: this.$t('ControlledDrugsRegisterRep.NurseBook') }
              ],
              show: 0,
              items: [],         
              fields: [
                { key: 'TransDate', sortable: true, label: this.$t('Shared.TransactionDate'), class: 'text-center' },
                { key: 'Trans', sortable: true, label: this.$t('Shared.TransactionType'), class: 'text-left' },
                { key: 'DrugCode', sortable: true, label: this.$t('drug.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('drug.Drugname'), class: 'text-left' },
                { key: 'Dosage', sortable: true, label: this.$t('ControlledDrugsRegisterRep.Dosage'), class: 'text-left' },
                { key: 'Form', sortable: true, label: this.$t('ControlledDrugsRegisterRep.Form'), class: 'text-center' },
                { key: 'IsControlledSubstance', sortable: true, label: this.$t('ControlledDrugsRegisterRep.IsControlledSubstance'), class: 'text-center' },
                { key: 'VoucherDate', sortable: true, label: this.$t('ControlledDrugsRegisterRep.VoucherDate'), class: 'text-center' },
                { key: 'InvoiceNumber', sortable: true, label: this.$t('ControlledDrugsRegisterRep.InvoiceNumber'), class: 'text-left' },
                { key: 'LocationFrom', sortable: true, label: this.$t('ControlledDrugsRegisterRep.LocationFrom'), class: 'text-left' },
                { key: 'LocationTo', sortable: true, label: this.$t('ControlledDrugsRegisterRep.LocationTo'), class: 'text-left' },
                { key: 'Balance', sortable: true, label: this.$t('ControlledDrugsRegisterRep.Balance'), class: 'text-right' },
                { key: 'QuantityReceived', sortable: true, label: this.$t('ControlledDrugsRegisterRep.QuantityReceived'), class: 'text-right' },
                { key: 'QuantityIssued', sortable: true, label: this.$t('ControlledDrugsRegisterRep.QuantityIssued'), class: 'text-right' },
                { key: 'PatientCode', sortable: true, label: this.$t('ControlledDrugsRegisterRep.PatientCode'), class: 'text-left' },
                { key: 'PatientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-left' },
                { key: 'PatientId', sortable: true, label: this.$t('Shared.PatientId'), class: 'hidden' },
                { key: 'DoctorName', sortable: true, label: this.$t('ControlledDrugsRegisterRep.DoctorName'), class: 'text-left' },
                { key: 'DoctorLicenseNumber', sortable: true, label: this.$t('ControlledDrugsRegisterRep.DoctorLicenseNumber'), class: 'text-left' },
                { key: 'PharmacistName', sortable: true, label: this.$t('ControlledDrugsRegisterRep.PharmacistName'), class: 'text-left' },
                { key: 'Remarks', sortable: true, label: this.$t('ControlledDrugsRegisterRep.Remarks'), class: 'text-left' },
                { key: 'SubSqlBalance', sortable: true, label: this.$t('ControlledDrugsRegisterRep.SubSqlBalance'), class: 'text-right' },
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'],
              UserName: StorageService.getName(),
              isDateFromValid: true,
              isDateToValid: true,
              AuxFields:['lastname'],
              fieldsDate:['dob'],
              BaseFields:[
                  { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                  { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
                  { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
                  { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
                  { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
                  { key: 'city', sortable: true, label: this.$t('Shared.City')},
                  { key: 'state', sortable: true, label: this.$t('Shared.State')},
                  { key: 'country', sortable: true, label: this.$t('Shared.Country')},
                  { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
              ]  
          }
      },
      methods: {

          getValues: function (value) {
              this.PatientCodeModel = value
              this.params.PatientCode = value.join(',')
          },

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          ChangeTran(values) {
            var trans = '';
            if (values && values.length > 0) {
                trans = values.map(x => x.value).join(',');
            }
            this.params.Tran = trans; 
          },

          ChangeDropDownPatients(values) {
            var pCodes = '';
            if (values && values.length > 0) {
                pCodes = values.map(x => x.patientcode).join(',');
            }
            this.params.PatientCode = pCodes; 
          },

          customLabelPatients ({ PatientName, patientcode }) {
            return `${PatientName} – ${patientcode}`
          },

          ChangeDropDownLoc(value){
            this.params.LocList = value.code; 
          },

          getPatients(){   
            const params = {
              SearchCriteria: '',
            }
            PatientService.getAll(params)
              .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0) {
                this.PatientsList = response.data;                 
                this.PatientsList.forEach(function(element) {	
                    element.PatientName = element.firstname + " " + element.lastname;  
                });       
              }       
              })
              .catch(error => {      
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });    
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pTran', paramValue: this.params.Tran})
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: this.params.PatientCode })
            this.reportParams.push({ paramName: 'pShow', paramValue: this.show})
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'pEnablePaging', paramValue: 0})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
            this.reportParams.push({ paramName: 'pUserName',  paramValue: this.UserName})
          },

          onClickShowReport() {
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportControlledDrugsFilters.buildDocument(this.reportParams)
          },

          LoadControlledDrugs() {
            if (!this.validateForm()) return;

            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugQuotedString = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
        
            this.parameter.PatientQuotedString = this.params.PatientCode && this.params.PatientCode !== '' 
                ? this.params.PatientCode
                : null;
            this.parameter.TransQuotedString = this.params.Tran && this.params.Tran !== '' 
                ? this.params.Tran
                : null;
            this.parameter.LocationQuotedString = this.params.LocList && this.params.LocList !== '' 
              ? this.params.LocList
              : null;
            this.parameter.Show = this.show;
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_WebControlledDrugRegister'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DrugQuotedString: this.parameter.DrugQuotedString,
                PatientQuotedString: this.parameter.PatientQuotedString,
                TransQuotedString: this.parameter.TransQuotedString,
                LocationQuotedString: this.parameter.LocationQuotedString,
                Show: this.parameter.Show,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  if (response.status == "200" && response.data) {
                    this.items = response.data;

                    this.items.forEach(function(element) {
                      let { VoucherDate, TransDate } = element
                      if (VoucherDate) element.VoucherDate = Utils.formatterDateToString(VoucherDate); 
                      if (TransDate) element.TransDate = Utils.formatterDateToString(TransDate);              
                    });
                    let headerString = response.headers["x-pagination"];
                    this.Header = JSON.parse(headerString);
                    this.totalRows = this.Header.TotalCount;
                    this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                    this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },

          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('ControlledDrugsRegister', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('ControlledDrugsRegister', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },

          // Método de validación reutilizable
          validateForm() {
            const isValid = this.validate_date_range();
       
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            // Forzar actualización del componente
            this.$forceUpdate();
            
            if (!isValid) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return true;
          },

      },
      created() {
       
      },

      mounted () {
        this.getPatients();
        this.getLocationsFilter();
        this.getDrugsFilter();
        
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
